// Job requests for /api/jobs (SEC-003). Each export describes a request by name; the fixed,
// parameterized GROQ lives server-side in netlify/lib/jobsApi.js, along with this site's board
// filter. Components pass these to client.fetch() (src/client.js). Pages are 10 jobs each.

//HomePage --Active
export const homePageJobsQuery = { name: 'latest' };

export const jobsPageQuery = (currentPage) => ({ name: 'list', page: currentPage });

//Jobview --Active
export const jobViewQuery = (jobId) => ({ name: 'job', id: jobId });

//cityJobView
export const cityJobs = (city, currentPage) => ({ name: 'city', city, page: currentPage });

//Search Query
// Location search: every word must match the city or the province (UX-009), done server-side.
export const searchQuery = (title, location, currentPage) => ({ name: 'search', title, location, page: currentPage });

export const titleQuery = (title, currentPage) => ({ name: 'search', title, page: currentPage });

export const locationQuery = (location, currentPage) => ({ name: 'search', location, page: currentPage });

export const titleQueryMax = (title) => ({ name: 'searchCount', title });
export const locationQueryMax = (location) => ({ name: 'searchCount', location });
export const searchQueryMax = (title, location) => ({ name: 'searchCount', title, location });

// Filter Query
export const partTimeQuery = (currentPage) => ({ name: 'list', category: 'Part-time', page: currentPage });

export const fullTimeQuery = (currentPage) => ({ name: 'list', category: 'Full-time', page: currentPage });

//Total Openings
export const totalOpenings = { name: 'count' };

//Total parttimeOpenings
export const totalPtOpenings = { name: 'count', category: 'Part-time' };

//Total fullTimeOpenings
export const totalFtOpenings = { name: 'count', category: 'Full-time' };

// Home page city tiles: the city of every listed post, counted client-side.
// Same filter as cityJobs/cityMax, so a tile's count matches its city page.
export const cityListQuery = { name: 'cities' };

export const cityMax = (city) => ({ name: 'cityCount', city });
